/* eslint-disable prettier/prettier */
import * as utils from './utils';
import * as yup from 'yup';
import { Thematique } from '../entities';

export const schemaThematique = yup.object<Partial<Thematique>>({
    name: yup.string().nullable(),
    description: yup.string().nullable(),
    fk_id_activite: yup.number().nullable(),
    debut: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    fin: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    ordreAffichage: yup.number().nullable().transform(utils.emptyStringToNullTransform),
    est_public: yup.boolean().nullable().default(true).transform(utils.nullBoolToFalse),
}) as yup.ObjectSchema<Partial<Thematique>>;
